export const URL_ORIGIN = "https://travel.ficom-it.info/";
